import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/stores";
import { DashboardData, DashboardService } from "@/domains/dashboard";

interface OperatorDashboardState {
  loading: boolean;
  data?: DashboardData;
}

const initialState: OperatorDashboardState = {
  loading: false,
  data: undefined,
};

export const operatorDashboardSelects = {
  loading: (state: RootState) => state.operatorDashboard.loading,
  data: (state: RootState) => state.operatorDashboard.data,
};

export const operatorDashboardThunks = {
  read: createAsyncThunk("operatorDashboard/read", async () => {
    const res = await DashboardService.read().run();
    return res.data.msg;
  }),
};

export const operatorDashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(operatorDashboardThunks.read.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(operatorDashboardThunks.read.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
    });
    builder.addCase(operatorDashboardThunks.read.rejected, (state) => {
      state.loading = false;
      // state.data = undefined;
    });
  },
});

export const operatorDashboardActions = operatorDashboardSlice.actions;
